import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { DateControl, Input, RadioButton, VehicleDamageCtrl, CarouselCtrl, InputFile, MapsCtrl, TimeCtrl, ModalMsgCtrl } from '../components'
import { catSiNo } from '../data/MochaData';
import http from "../../../services/http";
import { endPoints } from "../../../utils/constanst";
import { IconInfo } from '../img'



const Step4 = () => {
    const { ReclamosInspeccionNI, setReclamosInspeccionNI, changeHandler } = useContext(DataContext);
    const [modalLoading, setModalLoading] = useState({ isloading: true, txtMsg: 'Validando registro...', active: false } as IModalProps);

    const changeDate = (propierties: string, value: Date) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: value })
    const changeRadio = (propierties: string, value: boolean) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: value });
    const changeFiles = (propierties: string, files: Array<File>, isMod: boolean) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: files, [`${propierties}IsModified`]: isMod });

    useEffect(() => {
        LoadCatalog();
    }, [])


    const LoadCatalog = async () => {
        setModalLoading({ ...modalLoading, active: true, txtMsg: 'Cargando catalogos...' });
        await Promise.all([
            http(endPoints.getLstDamageType).get()
        ]).then(result => {
            setReclamosInspeccionNI({ ...ReclamosInspeccionNI, damageCatalog: JSON.parse(result[0].message) })
            setModalLoading({ ...modalLoading, active: false });
        }
        ).catch(() => setModalLoading({ ...modalLoading, active: false }))
    }


    const addVehicleDamage = (e: any) => {
        e.preventDefault();
        let max = ReclamosInspeccionNI.lstVehicleDamage?.sort((a: IVehicleDamage, b: IVehicleDamage) => (a.id - b.id));
        if (max !== undefined && max?.length > 0) {
            console.log(max);
            let dataNew: IVehicleDamage = {
                id: max[max.length - 1].id + 1,
                damageLevel: '',
                damageType: '',
                isProductAccident: ''
            } as IVehicleDamage
            max.push(dataNew);
            setReclamosInspeccionNI({ ...ReclamosInspeccionNI, lstVehicleDamage: max });
        }
    }

    const onChangeMapsMarker: any = (lat: number, lng: number) =>
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, sinisterLng: lng, sinisterLat: lat, sinisterGPS: `${lat},${lng}` });

    const onChangeTime: any = (time: any) => {
        const format = 'hh:mm a';
        let hour = time && time.format(format)
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, sinisterHour: time, sinisterHourFormat: hour });
    }



    return (
        <>
            <DateControl
                id='sinisterDate'
                label='Fecha del siniestro*'
                onChange={changeDate}
                value={ReclamosInspeccionNI.sinisterDate}
                placeholder='Seleccionar'
                maxDate={new Date()}
            />

            <TimeCtrl
                id='sinisterHour'
                value={ReclamosInspeccionNI.sinisterHour}
                label='Hora del siniestro*'
                onChange={onChangeTime}
                placeholder='Seleccionar'
            />
            <Input
                id='sinisterAddress'
                field='sinisterAddress'
                onChange={changeHandler}
                label='Dirección exacta de accidente*'
                value={ReclamosInspeccionNI.sinisterAddress}
                type='textarea'
                placeholder='Ingrese dirección exacta del siniestro'
            />
            <Input
                id='sinisterGPS'
                field='sinisterGPS'
                onChange={changeHandler}
                label='Ubicación GPS'
                value={ReclamosInspeccionNI.sinisterGPS}
                isReadOnly={true}
                placeholder='Activar GPS'
            />

            <MapsCtrl
                id='maps'
                lat={ReclamosInspeccionNI.sinisterLat}
                lng={ReclamosInspeccionNI.sinisterLng}
                apiKey={ReclamosInspeccionNI.apiKey}
                onChange={onChangeMapsMarker}
            />

            <RadioButton
                label='¿Se presentó un oficial de la Policia Nacional?*'
                field={'policeOfficerShowedUp'}
                key={'policeOfficerShowedUp'}
                value={ReclamosInspeccionNI.policeOfficerShowedUp}
                onChange={changeRadio}
                catalog={catSiNo}
            />

            {ReclamosInspeccionNI.policeOfficerShowedUp === 'N' && <div>
                <div className='lbl-input-re-ni mt-10' style={{ color: '#33BA75', lineHeight: '20px' }}>
                    <span>
                        Conforme al Arto. 35 de la Ley de Tránsito y sus reformas,
                        en caso de no presentarse un oficial de tránsito al lugar
                        del accidente, el asegurado debe presentarse
                        a la delegación de Policia más cercana para ingresar una denuncia.
                    </span>
                </div>
            </div>}

            {ReclamosInspeccionNI.policeOfficerShowedUp === 'S' && <div>
                <Input
                    id='policeChip'
                    field='policeChip'
                    onChange={changeHandler}
                    label='Ingrese el número de chip del Policia de Tránsito'
                    value={ReclamosInspeccionNI.policeChip}
                    placeholder='Ingrese el número de chip'
                    isRequired={false}
                    type='number'                    
                />
            </div>}

            <Input
                id='sinisterDetail'
                field='sinisterDetail'
                onChange={changeHandler}
                label='Detalles del siniestro*'
                value={ReclamosInspeccionNI.sinisterDetail}
                type='textarea'
                placeholder='Narra con todos los detalles cómo ocurrió el siniestro, quienes están involucrados y toda la información que consideres necesaria'
            />

            <CarouselCtrl />

            <div style={{display:'flex', justifyContent:'center'}}>
                <div className='mr-10'>
                   < IconInfo />
                </div>
                <label style={{ color: '#33BA75', lineHeight: '16px' }}>
               Recuerda guardar los daños marcados. Para ello, deberás presionar en el icono del casette cada vez que marques la imagen
                </label>
            </div>
        
            {ReclamosInspeccionNI.lstVehicleDamage?.map((detail: IVehicleDamage) => {
                return <VehicleDamageCtrl {...detail} />
            })}
            <div className='' style={{ display: 'flex' }}>
                <button className='btn-add-re-ni' onClick={addVehicleDamage}> + </button>
                <div className='ml-10 lbl-input-re-ni'>
                    Pulsá aquí para agregar más daños
                </div>
            </div>

            <Input
                id='inspectionObservations'
                field='inspectionObservations'
                onChange={changeHandler}
                label='Observaciones de la inspección*'
                value={ReclamosInspeccionNI.inspectionObservations}
                type='textarea'
                placeholder='Ingrese comentarios relacionados a los daños visualizados al vehículo asegurado'
            />

            <div className='lbl-paso-t1 mt-20 mb-20'>
                <span>Daños al vehículo asegurado</span>
            </div>

            <InputFile
                id='sinisterEnvironmentImage'
                label='Fotografías del entorno del siniestro*'
                files={ReclamosInspeccionNI.sinisterEnvironmentImage}
                onChange={changeFiles}
                maxFiles={4}
            />

            <InputFile
                id='frontVehicleImage'
                label='Fotografías a la parte delantera del vehículo asegurado*'
                files={ReclamosInspeccionNI.frontVehicleImage}
                onChange={changeFiles}
                maxFiles={2}
            />
            <InputFile
                id='backVehicleImage'
                label='Fotografías a la parte trasera del vehículo asegurado*'
                files={ReclamosInspeccionNI.backVehicleImage}
                onChange={changeFiles}
                maxFiles={2}
            />
            <InputFile
                id='rightVehicleImage'
                label='Fotografías al lateral derecho del vehículo asegurado*'
                files={ReclamosInspeccionNI.rightVehicleImage}
                onChange={changeFiles}
                maxFiles={2}
            />
            <InputFile
                id='leftVehicleImage'
                label='Fotografías al lateral izquierdo del vehículo asegurado*'
                files={ReclamosInspeccionNI.leftVehicleImage}
                onChange={changeFiles}
                maxFiles={2}
            />
            <InputFile
                id='damageVehicleImage'
                label='Fotografías de los daños del vehículo asegurado*'
                files={ReclamosInspeccionNI.damageVehicleImage}
                onChange={changeFiles}
                maxFiles={4}
            />

        </>
    )
}

export { Step4 }